import { ConversationParticipant } from '@centecomm/portal-service';
import React from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { conversationsSelectors } from 'State';
import { ParticipantJoinedConversation as ParticipantJoinedConversationEvent } from 'Types/Conversations/Events';
import styles from '../conversations.module.css';

interface ParticipantJoinedConversationProps {
    conversationId: number;
    event: ParticipantJoinedConversationEvent;
}

function ParticipantJoinedConversation({
    conversationId,
    event,
}: ParticipantJoinedConversationProps): React.ReactElement<ParticipantJoinedConversationProps> {
    useTranslation(['conversationsFeature']);
    const { userId } = event;

    const user: ConversationParticipant | undefined = useSelector(
        conversationsSelectors.conversationParticipant(conversationId, userId),
    );

    return (
        <div className={styles.SystemItem}>
            <p>
                {user ? (
                    <Trans
                        i18nKey="conversationsFeature:events.participantJoinedConversation.usernameJoined"
                        components={{
                            span: <span />,
                        }}
                        values={{ username: user.userName }}
                    />
                ) : (
                    <Trans
                        i18nKey="conversationsFeature:events.participantJoinedConversation.unknownUserJoined"
                        components={{
                            span: <span />,
                        }}
                    />
                )}
            </p>
        </div>
    );
}

export default ParticipantJoinedConversation;
